export default __webpack_public_path__ + "static/media/READY_TO_SCAN_PACKAGES.d4d4fcfe.svg";